import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '@shared/services';
import { ProfileAccessService } from '@shared/services/profile-access.service';

export const adminGuard: CanActivateFn = async (route, state) => {
    const userService = inject(UserService);
    const router = inject(Router);
    const profileAccess = inject(ProfileAccessService);

    const user = await userService.getCurrentUser().toPromise();

    // Verifica acesso: RMS JWT tem prioridade, fallback para isAdmin Firestore
    if (profileAccess.isAdmin(user)) {
        return true;
    }
    router.navigate(['/']);
    return false;
};
